// Remove the Translation import since it's not used
const translations = {
  app: {
    title: "Phone House",
    slogan: "Bienvenue à Phone House",
  },
  common: {
    dashboard: "Tableau de bord",
    newRepair: "Nouvelle réparation",
    search: "Rechercher",
    stock: "Stock & PDV",
    searchRepairs: "Rechercher des réparations",
    viewDetails: "Voir les détails",
    clickToView: "Cliquer pour voir",
    loading: "Chargement...",
    processing: "Traitement...",
    submit: "Soumettre",
    update: "Mettre à jour",
    delete: "Supprimer",
    cancel: "Annuler",
    save: "Enregistrer",
    edit: "Modifier",
    back: "Retour au",
    areYouSure: "Êtes-vous sûr(e) ?",
    success: "Succès !",
    error: "Erreur !",
    print: "Imprimer",
    download: "Télécharger",
    balance: "Solde",
    pageNotFound: "Oups ! Page non trouvée",
    returnHome: "Retour à l'accueil",
    copied: "Copié dans le presse-papiers",
    call: "Appeler",
    startScanning: "Commencer le scan",
    stopScanning: "Arrêter le scan",
    scannerActive: "Scanner actif et prêt",
    scannerInactive: "Scanner inactif",
    logo: "Logo",
    repairShop: "Atelier de Réparation",
    tel: "Tél",
    phone: "Téléphone",
    clear: "Effacer",
    edit: "Modifier",
    disabled: "Désactivé",
    featureDisabledMessage:
      "Cette fonctionnalité a été désactivée pour ce magasin.",
    enterSecurityCode: "Entrez le code de sécurité",
    invalidSecurityCode: "Code de sécurité invalide. Veuillez réessayer.",
    actions: "Actions",
    date: "Date",
  },
  repair: {
    repairs: "Réparations",
    createNew: "Créer une nouvelle réparation",
    repairDetails: "Détails de la réparation",
    repairTimeline: "Chronologie de la réparation",
    statusChanged: "Statut changé en",
    customerInfo: "Details du client",
    customerName: "Nom de client",
    customerPhone: "Num Tel",
    stat: "Statut",
    phoneModel: "modèle d'appareil",
    problemDescription: "Description du problème",
    observations: "Observations",
    observationsOptional: "(optionnel)",
    addObservation: "Ajouter une observation",
    noObservations: "Aucune observation pour le moment",
    observationAdded: "Observation ajoutée avec succès",
    observationAddError: "Échec de l'ajout de l'observation",
    repairPrice: "Prix de la réparation",
    initialPrice: "Prix Initial",
    totalPrice: "Prix Total",
    paymentStatus: "Statut du paiement",
    downPayment: "Acompte",
    priceModifications: "Modifications de Prix",
    priceModified: "Le prix a été modifié",
    addPriceModification: "Ajouter une Modification de Prix",
    priceModificationAdded: "Modification de prix ajoutée avec succès",
    priceModificationAddError: "Échec de l'ajout de la modification de prix",
    amount: "Montant",
    reason: "Raison",
    createdAt: "Date de création",
    completedAt: "Date de complétion",
    submitRepair: "Soumettre la réparation",
    successCreated: "Réparation créée avec succès !",
    failedCreated: "Erreur lors de la création de la réparation.",
    successUpdated: "Réparation mise à jour avec succès !",
    notFound: "Réparation non trouvée.",
    active: "Actives",
    completed: "Terminées",
    returned: "Retournées",
    all: "Toutes",
    noActiveRepairs: "Aucune réparation active trouvée",
    noCompletedRepairs: "Aucune réparation terminée trouvée",
    noReturnedRepairs: "Aucune réparation retournée trouvée",
    noRepairsFound: "Aucune réparation trouvée",
    createFirstRepair: "Créer votre première réparation",
    addedAgo: "Ajoutée il y a {{time}}",
    viewDetails: "Voir les détails",
    scanQrCode: "Scanner le QR Code",
    scanBarcode: "Scanner ce code-barres avec un scanner 1D",
    barcodeSticker: "Étiquette Code-barres",
    repairTicket: "Ticket de Réparation",
    ticketNumber: "Numéro de Ticket",
    qrCode: "QR Code",
    selectCodeType: "Sélectionner le Type de Code",
    selectCodeTypeDescription:
      "Choisissez quel type de code inclure sur le ticket imprimé",
    repairNumber: "Numéro de Réparation",
    thankYou: "Merci de votre confiance !",
    bringReceipt:
      "Veuillez apporter ce ticket lors de la récupération de votre appareil.",
    printTicket: "Imprimer le Ticket",
    updateStatus: "Mettre à jour le statut",
    deleteRepair: "Supprimer la réparation",
    deleteConfirmation:
      "Êtes-vous sûr(e) de vouloir supprimer cette réparation ? Cette action est irréversible.",
    enterDeleteCode: "Entrez le code de suppression",
    invalidDeleteCode: "Code de suppression invalide. Veuillez réessayer.",
    successDeleted: "Réparation supprimée avec succès !",
    payment: {
      paid: "Payé",
      partial: "Partiel",
      unpaid: "Non payé",
    },
    status: {
      pending: "En attente",
      inProgress: "En cours",
      completed: "Terminée",
      returned: "Retournée",
      cancelled: "Annulée",
    },
    addError: "Erreur lors de l'ajout de la réparation.",
    fetchError: "Erreur lors de la récupération des réparations.",
    updateError: "Erreur lors de la mise à jour de la réparation.",
    deleteError: "Erreur lors de la suppression de la réparation.",
    importError: "Erreur lors de l'importation des réparations.",
    noRepairFoundWithTicket:
      "Aucune réparation trouvée avec ce numéro de ticket. Veuillez vérifier et réessayer.",
    noTicketNumberForBarcode:
      "Aucun numéro de ticket disponible pour générer le code-barres.",
  },
  searchRepairs: {
    title: "Rechercher des réparations",
    noResults: "Aucune réparation trouvée",
    adjustFilters: "Essayez d'ajuster votre recherche ou vos filtres",
  },
  filters: {
    title: "Filtres",
    slogan: "Appliquer des filtres pour affiner votre recherche",
    status: "Statut",
    payment: "Paiement",
    clear: "Effacer les filtres",
    anyStatus: "Tous les statuts",
    anyPaymentStatus: "Tous les statuts de paiement",
    clearAll: "Effacer tous les filtres",
    dateFrom: "Date de début",
    dateTo: "Date de fin",
  },
  importExport: {
    import: "Importer",
    export: "Exporter",
    importRepairs: "Importer des Réparations",
    exportRepairs: "Exporter les Réparations",
    importDescription: "Importer les réparations à partir d'un fichier JSON",
    exportDescription: "Exporter toutes les réparations vers un fichier JSON",
    selectFile: "Sélectionner un fichier",
    downloadFile: "Télécharger le fichier",
    uploadFile: "Téléverser le fichier",
    chooseFile: "Choisir un fichier",
    downloadTemplate: "Télécharger le modèle",
    importedSuccess: "Réparations importées avec succès !",
    exportedSuccess: "Réparations exportées avec succès !",
    invalidFile:
      "Format de fichier invalide. Veuillez utiliser un fichier JSON valide.",
    importConfirmation:
      "Êtes-vous sûr(e) de vouloir importer ces réparations ? Cela écrasera toutes les données existantes.",
    successImport: "Réparations importées avec succès !",
    failedImport: "Erreur lors de l'importation des réparations.",
    successExport: "Réparations exportées avec succès !",
    failedExport: "Erreur lors de l'exportation des réparations.",
  },
  analytics: {
    title: "Analytiques de paiement",
    totalAmountPaid: "Montant total payé",
    averageAmountPaid: "Montant moyen payé",
    monthlyRevenue: "Recettes mensuelles",
  },
  repairAnalytics: {
    title: "Statistiques des Réparations",
    totalRepairs: "Nombre total de réparations",
    completedRepairs: "Réparations terminées",
    pendingRepairs: "Réparations en attente",
    totalRevenue: "Revenu total",
    averageRepairPrice: "Prix moyen par réparation",
  },
  auth: {
    login: "Connexion",
    logout: "Déconnexion",
    email: "Email",
    password: "Mot de passe",
    loginToContinue: "Connectez-vous pour continuer",
    genericError: "Une erreur s'est produite lors de la connexion",
    emailRequired: "L'email est requis",
    passwordRequired: "Le mot de passe est requis",
    invalidCredentials: "Email ou mot de passe incorrect",
  },
  languageSwitcher: {
    language: "Langue",
    english: "Anglais",
    french: "Français",
    arabic: "Arabe",
  },
  repairShop: {
    title: "Atelier de Réparation",
    name: "Nom de l'atelier",
    address: "Adresse",
    phone: "Téléphone",
    fetchError: "Erreur lors de la récupération des informations de l'atelier",
  },
  scanner: {
    henexScanner: "Scanner Dédié",
    cameraScanner: "Scanner Caméra",
    barcode: "Code-barres",
    henexInstructions:
      "Le scanner dédié est actif. Scannez un code-barres ou QR code directement",
    scannerInstructions:
      "Appuyez sur le bouton du scanner pour scanner un code",
    scanPlaceholder: "Scanner un code...",
    scanSuccess: "Code scanné avec succès!",
    scanError: "Erreur lors du scan du code. Veuillez réessayer.",
    autoScanEnabled: "Scan automatique activé",
    readyToScan: "Prêt à scanner",
    scanningActive: "Scanner actif",
  },
  shortcuts: {
    title: "Raccourcis clavier",
    description: "Utilisez ces raccourcis clavier pour naviguer rapidement",
    keyboard: "Raccourcis",
    showShortcuts: "Afficher les raccourcis clavier",
    tip: "Appuyez sur ? à tout moment pour afficher cette aide",
    goToDashboard: "Aller au tableau de bord (Alt+H)",
    newRepair: "Créer une nouvelle réparation (Alt+N)",
    printCurrentRepair: "Imprimer la réparation actuelle (Alt+P)",
    help: "Afficher les raccourcis clavier (?)",
    navigatedToDashboard: "Navigation vers le tableau de bord",
    creatingNewRepair: "Création d'une nouvelle réparation",
    printing: "Impression...",
  },
  theme: {
    light: "Clair",
    dark: "Sombre",
    system: "Système",
    toggleDarkMode: "Basculer en mode sombre",
  },
  dashboard: {
    title: "Tableau de bord",
    editLayout: "Modifier la disposition",
    saveLayout: "Enregistrer la disposition",
    reset: "Réinitialiser",
    addWidget: "Ajouter un widget",
    widgetAdded: "Widget ajouté avec succès",
    widgetRemoved: "Widget supprimé",
    dashboardReset: "Tableau de bord réinitialisé aux paramètres par défaut",
    widgetType: "Type de widget",
    widgetTitle: "Titre du widget",
    selectWidgetType: "Sélectionner le type de widget",
    addWidgetDescription:
      "Choisissez un type de widget et personnalisez son titre",
    totalRepairs: "Total des réparations",
    repairs: "Réparations",
    noRepairsFound: "Aucune réparation trouvée",
    unknownDevice: "Appareil inconnu",
    goodMorning: "Bonjour",
    goodAfternoon: "Bon après-midi",
    goodEvening: "Bonsoir",
    user: "Utilisateur",
    welcomeMessage:
      "Bienvenue sur votre tableau de bord personnalisé. Vous pouvez voir ici un aperçu de votre atelier de réparation.",
    widgets: {
      welcome: {
        title: "Bienvenue",
        defaultTitle: "Bienvenue",
      },
      "repair-status": {
        title: "État des réparations",
        defaultTitle: "État des réparations",
      },
      "recent-repairs": {
        title: "Réparations récentes",
        defaultTitle: "Réparations récentes",
      },
      "repairs-by-status": {
        title: "Réparations par statut",
        defaultTitle: "Réparations par statut",
      },
      "repairs-by-device": {
        title: "Réparations par appareil",
        defaultTitle: "Réparations par appareil",
      },
      "payment-status": {
        title: "État des paiements",
        defaultTitle: "État des paiements",
      },
      income: {
        title: "Revenus",
        defaultTitle: "Revenus",
      },
    },
    paid: "Payé",
    unpaid: "Non payé",
    partial: "Partiellement payé",
    noPaymentData: "Aucune donnée de paiement disponible",
    monthlyIncome: "Revenu mensuel",
    totalIncome: "Revenu total",
    income: "Revenu",
    increase: "augmentation",
    decrease: "diminution",
    allTime: "Tout le temps",
  },
  data: {
    export: "Exporter les données",
    import: "Importer les données",
    successExport: "Données exportées avec succès",
    failedExport: "Échec de l'exportation des données",
    successImport: "Données importées avec succès",
    failedImport: "Échec de l'importation des données",
  },
  stock: {
    title: "Gestion de Stock & PDV",
    pos: "Point de Vente",
    allCategories: "Toutes les Catégories",
    products: "Produits",
    categories: "Catégories",
    sales: "Ventes",
    inventory: "Inventaire",
    reports: "Rapports",

    // Product Management
    addProduct: "Ajouter Produit",
    editProduct: "Modifier Produit",
    deleteProduct: "Supprimer Produit",
    productName: "Nom du Produit",
    productDescription: "Description",
    sku: "SKU",
    barcode: "Code-barres",
    category: "Catégorie",
    price: "Prix",
    cost: "Coût",
    stock: "Stock",
    minStock: "Stock Min",
    maxStock: "Stock Max",
    isActive: "Actif",
    image: "Image",

    // Categories
    addCategory: "Ajouter Catégorie",
    editCategory: "Modifier Catégorie",
    categoryName: "Nom de Catégorie",
    categoryDescription: "Description de Catégorie",

    // POS Interface
    cart: "Panier",
    addToCart: "Ajouter au Panier",
    removeFromCart: "Retirer",
    clearCart: "Vider le Panier",
    quantity: "Quantité",
    unitPrice: "Prix Unitaire",
    discount: "Remise",
    subtotal: "Sous-total",
    tax: "Taxe",
    total: "Total",

    // Payment
    payment: "Paiement",
    paymentMethod: "Méthode de Paiement",
    cash: "Espèces",
    card: "Carte",
    mobile: "Paiement Mobile",
    mixed: "Paiement Mixte",
    amountPaid: "Montant Payé",
    change: "Monnaie",
    processSale: "Traiter la Vente",

    // Customer
    customer: "Client",
    customerName: "Nom du Client",
    customerPhone: "Téléphone du Client",

    // Sales
    saleNumber: "Vente #",
    saleDate: "Date de Vente",
    saleTotal: "Total de Vente",
    viewSale: "Voir Vente",

    // Inventory
    lowStock: "Stock Faible",
    outOfStock: "Rupture de Stock",
    stockLevel: "Niveau de Stock",
    stockMovement: "Mouvement de Stock",
    stockIn: "Entrée de Stock",
    stockOut: "Sortie de Stock",
    adjustment: "Ajustement",
    totalProducts: "Total Produits",
    totalCostValue: "Valeur Coût Total",
    totalSellValue: "Valeur Vente Total",
    totalValue: "Valeur Totale",

    // Repair Parts
    repairParts: "Pièces de Réparation",
    addRepairPart: "Ajouter Pièce",
    editRepairPart: "Modifier Pièce",
    deleteRepairPart: "Supprimer Pièce",
    partName: "Nom de la Pièce",
    partDescription: "Description de la Pièce",
    partCost: "Coût de la Pièce",
    partStock: "Stock de Pièces",
    selectParts: "Sélectionner Pièces",
    partsUsed: "Pièces Utilisées",
    partsCost: "Coût des Pièces",
    noPartsSelected: "Aucune pièce sélectionnée",
    addParts: "Ajouter Pièces",
    removePart: "Retirer Pièce",
    repairPartAdded: "Pièce de réparation ajoutée avec succès",
    repairPartUpdated: "Pièce de réparation mise à jour avec succès",
    repairPartDeleted: "Pièce de réparation supprimée avec succès",
    repairPartsManagement: "Gestion des Pièces de Réparation",
    totalPartsCost: "Coût Total des Pièces",
    stockMovements: "Mouvements de Stock",
    recentStockOperations: "Opérations de Stock Récentes",
    noStockMovements: "Aucun mouvement de stock",
    operation: "Opération",

    // Messages
    productAdded: "Produit ajouté avec succès",
    productUpdated: "Produit mis à jour avec succès",
    productDeleted: "Produit supprimé avec succès",
    categoryAdded: "Catégorie ajoutée avec succès",
    categoryUpdated: "Catégorie mise à jour avec succès",
    categoryDeleted: "Catégorie supprimée avec succès",
    saleCompleted: "Vente terminée avec succès",
    insufficientStock: "Stock insuffisant",
    invalidQuantity: "Quantité invalide",
    fetchError: "Erreur de récupération des données",
    addError: "Erreur d'ajout d'élément",
    updateError: "Erreur de mise à jour d'élément",
    deleteError: "Erreur de suppression d'élément",
    saleError: "Erreur de traitement de vente",
    stockAdjusted: "Stock ajusté avec succès",
    adjustError: "Erreur d'ajustement de stock",

    // Touch Interface
    touchMode: "Mode Tactile",
    gridView: "Vue Grille",
    listView: "Vue Liste",
    searchProducts: "Rechercher des produits...",

    // Barcode Scanner
    scan: "Scanner",
    scanBarcode: "Scanner Code-barres",
    barcodeScanner: "Scanner de Code-barres",
    manualEntry: "Saisie Manuelle",
    cameraScanner: "Scanner Caméra",
    enterBarcode: "Entrer Code-barres",
    addToCart: "Ajouter au Panier",
    productNotFound: "Produit non trouvé",
    productInactive: "Produit inactif",
    productOutOfStock: "Produit en rupture de stock",
    barcodeAdded: "Produit ajouté au panier via code-barres",
    scannerActive: "Scanner Actif - Prêt à scanner",
    scanning: "Scan en cours",
    scannerInstructions: "Le scan automatique de codes-barres est actif :",
    useBarcodeScannerDevice: "Utiliser un scanner",
    typeBarcodeDirect: "Taper directement",
    automaticCartAdd: "Ajout auto au panier",

    // Sales Ticket & Printing
    salesTicket: "Ticket de Vente",
    printTicket: "Imprimer Ticket",
    print: "Imprimer",
    saleNumber: "Numéro de Vente",
    date: "Date",
    items: "Articles",
    discount: "Remise",
    paid: "Payé",
    partial: "Partiel",
    pending: "En attente",
    thankYouVisit: "Merci de votre visite !",
    keepTicket: "Veuillez conserver ce ticket",
    printInstructions1: "Optimisé pour imprimantes thermiques 80mm",
    printInstructions2: "Assurez-vous que l'imprimante est prête",
    printInstructions3: "Cliquez Imprimer pour générer le reçu",

    // Sales History
    todaysSales: "Ventes d'Aujourd'hui",
    todaysRevenue: "Revenus d'Aujourd'hui",
    totalSales: "Total des Ventes",
    noSalesYet: "Aucune vente encore",
    walkInCustomer: "Client de Passage",
    saleId: "ID de Vente",
    totalValue: "Valeur Totale",
    noLowStockItems: "Aucun article en stock faible",
    noOutOfStockItems: "Aucun article en rupture",

    // Barcode Scanner
    cameraStarted: "Caméra démarrée. Pointez vers le code-barres pour scanner.",
    cameraError:
      "Impossible d'accéder à la caméra. Veuillez utiliser la saisie manuelle.",
    manualEntry: "Manuel",
    cameraScanner: "Caméra",
    enterBarcodeManually: "Saisir le Code-Barres Manuellement",
    enterOrScanBarcode: "Saisir ou scanner le code-barres...",
    pointCameraAtBarcode: "Pointez la caméra vers le code-barres pour scanner",
    orTypeBarcodeHere: "Ou tapez le code-barres ici...",
    cameraNotStarted: "Caméra non démarrée",
    startCamera: "Démarrer la Caméra",

    // Barcode Sticker
    generateSticker: "Générer Étiquette",
    printSticker: "Imprimer Étiquette",
    generateBarcode: "Générer Code-barres",
    generateEAN13Barcode: "Générer Code-barres EAN13",
    barcodeSticker: "Étiquette Code-barres",
    stickerPreview: "Aperçu de l'Étiquette",
    copies: "Copies",
    productNeedsBarcode: "Ce produit a besoin d'un code-barres",
    addBarcodeToProduct:
      "Ajoutez un code-barres à ce produit pour imprimer des étiquettes",
    generateNewBarcode:
      "Ce produit n'a pas de code-barres. Générez-en un ci-dessous.",

    // Product Management
    showInactive: "Afficher Inactifs",
    hideInactive: "Masquer Inactifs",
    inactive: "Inactif",
    product: "Produit",
    sku: "SKU",
    price: "Prix",
    stock: "Stock",
    status: "Statut",
    actions: "Actions",
    tryAdjustingSearch: "Essayez d'ajuster vos termes de recherche",
    getStartedAddProduct: "Commencez par ajouter votre premier produit",

    // POS Interface Messages
    cartIsEmpty: "Le panier est vide",
    insufficientPayment: "Montant de paiement insuffisant",
    saleFailed: "Échec de la vente",
    unknownError: "Erreur inconnue",
    saleProcessedSuccessfully: "Vente traitée avec succès !",

    // Quick Setup
    userOrShopNotFound: "Utilisateur ou atelier non trouvé",
    errorCheckingSetup: "Erreur lors de la vérification de la configuration",
    errorCreatingSampleData: "Erreur lors de la création des données d'exemple",
    sampleDataCreatedSuccessfully: "Données d'exemple créées avec succès !",
    checking: "Vérification...",
    checkSetup: "Vérifier la Configuration",
    createSampleData: "Créer des Données d'Exemple",

    // Product Form
    priceAndCostMustBePositive:
      "Le prix et le coût doivent être des nombres positifs",
    enterProductName: "Saisir le nom du produit",
    enterSKU: "Saisir le SKU",
    enterProductDescription: "Saisir la description du produit",
    enterBarcode: "Saisir le code-barres",
    searchProducts: "Rechercher des produits...",

    // Stock Validation Messages
    productNoLongerExists: "Le produit n'existe plus",
    productNoLongerActive: "Le produit n'est plus actif",
    insufficientStockDetailed:
      "Stock insuffisant pour {{productName}}. Disponible: {{available}}, Requis: {{required}}",

    // Advanced POS Features
    holdOrder: "Mettre en Attente",
    heldOrders: "Commandes en Attente",
    recallOrder: "Rappeler Commande",
    deleteOrder: "Supprimer Commande",
    orderHeld: "Commande mise en attente avec succès",
    orderRecalled: "Commande rappelée avec succès",
    orderDeleted: "Commande supprimée avec succès",
    applyDiscount: "Appliquer Remise",
    orderDiscount: "Remise Commande",
    itemDiscount: "Remise Article",
    discountType: "Type de Remise",
    percentage: "Pourcentage",
    fixedAmount: "Montant Fixe",
    discountValue: "Valeur de Remise",
    discountApplied: "Remise appliquée avec succès",
    notes: "Notes",
    addNotes: "Ajouter Notes",
    orderNotes: "Notes de Commande",
    noHeldOrders: "Aucune commande en attente",
    heldOn: "Mise en attente le",
    orderTotal: "Total Commande",
    discountAmount: "Montant de Remise",
    cart: "Panier",
    customer: "Client",
    customerName: "Nom du client",
    customerPhone: "Téléphone du client",
    payment: "Paiement",
    subtotal: "Sous-total",
    tax: "Taxe",
    total: "Total",
    paymentMethod: "Méthode de paiement",
    cash: "Espèces",
    card: "Carte",
    mobile: "Mobile",
    amountPaid: "Montant payé",
    change: "Monnaie",
    processSale: "Traiter la vente",
    insufficientStock: "Stock insuffisant",

    // Password Protection
    confirmProductCreation: "Confirmer la Création de Produit",
    confirmProductUpdate: "Confirmer la Mise à Jour de Produit",
    confirmProductDeletion: "Confirmer la Suppression de Produit",
    confirmCategoryCreation: "Confirmer la Création de Catégorie",
    confirmCategoryUpdate: "Confirmer la Mise à Jour de Catégorie",
    confirmCategoryDeletion: "Confirmer la Suppression de Catégorie",
    productCreationWarning:
      "Cette action créera un nouveau produit dans votre inventaire. Veuillez saisir le code d'accès pour continuer.",
    productUpdateWarning:
      "Cette action modifiera un produit existant dans votre inventaire. Veuillez saisir le code d'accès pour continuer.",
    productDeletionWarning:
      "Cette action supprimera définitivement le produit de votre inventaire. Cette action ne peut pas être annulée. Veuillez saisir le code d'accès pour continuer.",
    categoryCreationWarning:
      "Cette action créera une nouvelle catégorie dans votre inventaire. Veuillez saisir le code d'accès pour continuer.",
    categoryUpdateWarning:
      "Cette action modifiera une catégorie existante dans votre inventaire. Veuillez saisir le code d'accès pour continuer.",
    categoryDeletionWarning:
      "Cette action supprimera définitivement la catégorie de votre inventaire. Cette action ne peut pas être annulée. Veuillez saisir le code d'accès pour continuer.",
    updateProduct: "Mettre à Jour le Produit",
    updateCategory: "Mettre à Jour la Catégorie",
    deleteCategory: "Supprimer la Catégorie",
    cannotDeleteCategory:
      "Impossible de supprimer la catégorie. Elle contient {{count}} produits. Veuillez déplacer ou supprimer les produits d'abord.",

    // Daily Summary
    dailySummary: "Résumé Quotidien",
    totalRevenue: "Chiffre d'Affaires Total",
    totalTransactions: "Total des Transactions",
    transactions: "Transactions",
    avgTransaction: "Transaction Moyenne",
    itemsSold: "Articles Vendus",
    paymentBreakdown: "Méthodes de Paiement",
    peakHour: "Heure de Pointe",
    printSummary: "Imprimer le Résumé",
    exportSummary: "Exporter le Résumé",
    selectDateRange: "Sélectionner la Période",
    today: "Aujourd'hui",
    yesterday: "Hier",
    thisWeek: "Cette Semaine",
    thisMonth: "Ce Mois",
    customRange: "Période Personnalisée",
    from: "Du",
    to: "Au",
    apply: "Appliquer",

    // Empty States
    emptyCart: {
      title: "Votre panier est vide",
      subtitle: "Ajoutez des produits pour commencer",
      action: "Parcourir les Produits",
      tip: "Scannez un code-barres ou cliquez sur les produits pour les ajouter",
    },
    emptyProducts: {
      title: "Aucun produit trouvé",
      subtitle: "Essayez d'ajuster votre recherche ou filtre de catégorie",
      action: "Effacer les Filtres",
      tip: "Assurez-vous que les produits sont ajoutés à votre inventaire",
    },
  },
  finance: {
    title: "Gestion Financière",
    expenses: "Dépenses",
    suppliers: "Fournisseurs",
    clientCredit: "Crédit Client",
    addExpense: "Ajouter Dépense",
    addSupplier: "Ajouter Fournisseur",
    addClient: "Ajouter Client",
    recordPurchase: "Enregistrer Achat",
    newTransaction: "Nouvelle Transaction",
    description: "Description",
    amount: "Montant",
    category: "Catégorie",
    date: "Date",
    name: "Nom",
    phone: "Téléphone",
    email: "Email",
    address: "Adresse",
    supplier: "Fournisseur",
    product: "Produit",
    quantity: "Quantité",
    totalCost: "Coût Total",
    amountPaid: "Montant Payé",
    amountOwed: "Montant Dû",
    purchaseDate: "Date d'Achat",
    notes: "Notes",
    addToStock: "Ajouter la quantité au stock",
    creditLimit: "Limite de Crédit",
    currentBalance: "Solde Actuel",
    type: "Type",
    purchase: "Achat (Ajouter Crédit)",
    payment: "Paiement (Réduire Crédit)",
    creditAdjustment: "Ajustement de Crédit",
    receiptNumber: "Numéro de Reçu",
    totalExpenses: "Total des Dépenses",
    totalOwed: "Total Dû",
    totalCredit: "Crédit Total",
    noExpenses: "Aucune dépense enregistrée",
    noSuppliers: "Aucun fournisseur ajouté",
    noPurchases: "Aucun achat enregistré",
    noClients: "Aucun client ajouté",
    noTransactions: "Aucune transaction enregistrée",
    expenseAdded: "Dépense ajoutée",
    expenseDeleted: "Dépense supprimée",
    supplierAdded: "Fournisseur ajouté",
    supplierUpdated: "Fournisseur mis à jour",
    supplierDeleted: "Fournisseur supprimé",
    purchaseRecorded: "Achat enregistré",
    paymentRecorded: "Paiement enregistré",
    clientAdded: "Client ajouté",
    clientUpdated: "Client mis à jour",
    transactionRecorded: "Transaction enregistrée",
    pay: "Payer",
    recordPayment: "Enregistrer Paiement",
    paymentAmount: "Montant du Paiement",
    purchases: "Achats",
    clients: "Clients",
    transactions: "Transactions",
    limit: "Limite",
    balance: "Solde",
    paid: "Payé",
    owed: "Dû",
  },
};

export default translations;
